// src/utils/googleAnalytics.ts
import ReactGA from 'react-ga4';

export const GA_MEASUREMENT_ID = 'G-X1HX25HCGP'; 

export const initGA = () => {
  if (GA_MEASUREMENT_ID) {
    ReactGA.initialize(GA_MEASUREMENT_ID);
    console.log('GA Initialized');
  }
};

export const logPageView = (path: string) => {
  if (GA_MEASUREMENT_ID) {
    ReactGA.send({ hitType: 'pageview', page: path, title: document.title });
    console.log('Page view logged:', path);
  }
};

export const logEvent = (category: string, action: string, label?: string, value?: number) => {
  if (GA_MEASUREMENT_ID) {
    ReactGA.event({
      category: category,
      action: action,
      label: label,
      value: value,
    });
    console.log('Event logged:', category, action, label, value);
  }
};